export function QrBadgeIcon({ size = 16.5 }: { size?: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
        d="M4 9V5h4M20 9V5h-4M4 15v4h4M20 15v4h-4"
      />
      <path fill="currentColor" d="M7 7h4v4H7zm6 0h2v2h-2zm2 2h2v2h-2zm-2 2h2v2h-2zM7 13h2v2H7zm2 2h2v2H7v-2zm4 0h2v2h-2zm2-2h2v4h-2zm2-2h2v2h-2z" />
    </svg>
  );
}
